import { UntypedFormGroup, UntypedFormControl, UntypedFormArray, Validators } from '@angular/forms';

import { PcgTableColumn } from '../../../table/interfaces/pcg-table-column.interface';

export class GlobalAuditHistoryVm {
	dateChanged: Date;
	dateChangedFormatted?: string;
	businessArea?: any;
	module?: string;
	entityId?: number;
	recordAffected?: string;
	secureArea?: string;
	field?: string;
	changedFrom?: string;
	changedTo?: string;
	changedBy?: string;
	pfsLink?: string;

	static get FormData() {
		return this.getFormData();
	}

	static getFormData(validators = {}) {
		return {
			'dateChanged': new UntypedFormControl('', [...(validators['dateChanged'] ?? []), ...[Validators.required]]),
			'dateChangedFormatted': new UntypedFormControl(null, [...(validators['dateChangedFormatted'] ?? []), ...[]]),
			'businessArea': new UntypedFormControl(null, [...(validators['businessArea'] ?? []), ...[]]),
			'module': new UntypedFormControl(null, [...(validators['module'] ?? []), ...[]]),
			'entityId': new UntypedFormControl(null, [...(validators['entityId'] ?? []), ...[]]),
			'recordAffected': new UntypedFormControl(null, [...(validators['recordAffected'] ?? []), ...[]]),
			'secureArea': new UntypedFormControl(null, [...(validators['secureArea'] ?? []), ...[]]),
			'field': new UntypedFormControl(null, [...(validators['field'] ?? []), ...[]]),
			'changedFrom': new UntypedFormControl(null, [...(validators['changedFrom'] ?? []), ...[]]),
			'changedTo': new UntypedFormControl(null, [...(validators['changedTo'] ?? []), ...[]]),
			'changedBy': new UntypedFormControl(null, [...(validators['changedBy'] ?? []), ...[]]),
			'pfsLink': new UntypedFormControl(null, [...(validators['pfsLink'] ?? []), ...[]])
		};
	}

	static get Form() {
		return new UntypedFormGroup(this.FormData);
	}

	static get ColumnDefs(): Map<string, PcgTableColumn> {
		return new Map([
			['dateChanged', {"orderId":0,"sortColumn":"dateChanged","searchColumn":"dateChanged","includeInExcel":true,"exportColumns":null,"displayName":"Date Changed","isVisible":true,"canSearch":true,"isNdc":false,"isNdc10":false,"isSum":false,"multiSearchCellClasses":null,"requiresFullAccess":false,"cellClass":"th-width-13","cellTransform":null,"cellNavigationColumn":null,"canSort":true,"isCurrency":false,"isPercent":false,"isEditableField":false,"headerTooltip":"","isPrint":true,"exportFormat":null}],
			['businessArea', {"orderId":1,"sortColumn":"businessArea","searchColumn":"businessArea","includeInExcel":true,"exportColumns":null,"displayName":"Business Area","isVisible":true,"canSearch":true,"isNdc":false,"isNdc10":false,"isSum":false,"multiSearchCellClasses":null,"requiresFullAccess":false,"cellClass":null,"cellTransform":null,"cellNavigationColumn":null,"canSort":false,"isCurrency":false,"isPercent":false,"isEditableField":false,"headerTooltip":"","isPrint":true,"exportFormat":null}],
			['module', {"orderId":2,"sortColumn":"module","searchColumn":"module","includeInExcel":true,"exportColumns":null,"displayName":"Module","isVisible":true,"canSearch":true,"isNdc":false,"isNdc10":false,"isSum":false,"multiSearchCellClasses":null,"requiresFullAccess":false,"cellClass":null,"cellTransform":null,"cellNavigationColumn":null,"canSort":false,"isCurrency":false,"isPercent":false,"isEditableField":false,"headerTooltip":"","isPrint":true,"exportFormat":null}],
			['entityId', {"orderId":3,"sortColumn":"entityId","searchColumn":"entityId","includeInExcel":true,"exportColumns":null,"displayName":"DB #","isVisible":false,"canSearch":true,"isNdc":false,"isNdc10":false,"isSum":false,"multiSearchCellClasses":null,"requiresFullAccess":false,"cellClass":null,"cellTransform":null,"cellNavigationColumn":null,"canSort":false,"isCurrency":false,"isPercent":false,"isEditableField":false,"headerTooltip":"","isPrint":true,"exportFormat":null}],
			['recordAffected', {"orderId":4,"sortColumn":"recordAffected","searchColumn":"recordAffected","includeInExcel":true,"exportColumns":null,"displayName":"Record Affected","isVisible":true,"canSearch":true,"isNdc":false,"isNdc10":false,"isSum":false,"multiSearchCellClasses":null,"requiresFullAccess":false,"cellClass":null,"cellTransform":null,"cellNavigationColumn":null,"canSort":false,"isCurrency":false,"isPercent":false,"isEditableField":false,"headerTooltip":"","isPrint":true,"exportFormat":null}],
			['secureArea', {"orderId":5,"sortColumn":"secureArea","searchColumn":"secureArea","includeInExcel":true,"exportColumns":null,"displayName":"Secure Area?","isVisible":true,"canSearch":true,"isNdc":false,"isNdc10":false,"isSum":false,"multiSearchCellClasses":null,"requiresFullAccess":false,"cellClass":null,"cellTransform":null,"cellNavigationColumn":null,"canSort":false,"isCurrency":false,"isPercent":false,"isEditableField":false,"headerTooltip":"","isPrint":true,"exportFormat":null}],
			['field', {"orderId":6,"sortColumn":"field","searchColumn":"field","includeInExcel":true,"exportColumns":null,"displayName":"Field","isVisible":true,"canSearch":true,"isNdc":false,"isNdc10":false,"isSum":false,"multiSearchCellClasses":null,"requiresFullAccess":false,"cellClass":null,"cellTransform":null,"cellNavigationColumn":null,"canSort":false,"isCurrency":false,"isPercent":false,"isEditableField":false,"headerTooltip":"","isPrint":true,"exportFormat":null}],
			['changedFrom', {"orderId":7,"sortColumn":"changedFrom","searchColumn":"changedFrom","includeInExcel":true,"exportColumns":null,"displayName":"Changed From","isVisible":true,"canSearch":true,"isNdc":false,"isNdc10":false,"isSum":false,"multiSearchCellClasses":null,"requiresFullAccess":false,"cellClass":null,"cellTransform":null,"cellNavigationColumn":null,"canSort":false,"isCurrency":false,"isPercent":false,"isEditableField":false,"headerTooltip":"","isPrint":true,"exportFormat":null}],
			['changedTo', {"orderId":8,"sortColumn":"changedTo","searchColumn":"changedTo","includeInExcel":true,"exportColumns":null,"displayName":"Changed To","isVisible":true,"canSearch":true,"isNdc":false,"isNdc10":false,"isSum":false,"multiSearchCellClasses":null,"requiresFullAccess":false,"cellClass":null,"cellTransform":null,"cellNavigationColumn":null,"canSort":false,"isCurrency":false,"isPercent":false,"isEditableField":false,"headerTooltip":"","isPrint":true,"exportFormat":null}],
			['changedBy', {"orderId":9,"sortColumn":"changedBy","searchColumn":"changedBy","includeInExcel":true,"exportColumns":null,"displayName":"Changed By","isVisible":true,"canSearch":true,"isNdc":false,"isNdc10":false,"isSum":false,"multiSearchCellClasses":null,"requiresFullAccess":false,"cellClass":null,"cellTransform":null,"cellNavigationColumn":null,"canSort":false,"isCurrency":false,"isPercent":false,"isEditableField":false,"headerTooltip":"","isPrint":true,"exportFormat":null}]
		]);
	}

	static GetModel(fg: UntypedFormGroup): GlobalAuditHistoryVmFromFg {
		return new GlobalAuditHistoryVmFromFg(fg);
	}
}

export class GlobalAuditHistoryVmFromFg {
	constructor(public fg: UntypedFormGroup) { }


	get dateChanged(): Date {
		return this.fg.get('dateChanged').value;
	}
	set dateChanged(val) {
		this.fg.get('dateChanged').setValue(val);
	}

	get dateChangedFormatted(): string {
		return this.fg.get('dateChangedFormatted').value;
	}
	set dateChangedFormatted(val) {
		this.fg.get('dateChangedFormatted').setValue(val);
	}

	get businessArea(): any {
		return this.fg.get('businessArea').value;
	}
	set businessArea(val) {
		this.fg.get('businessArea').setValue(val);
	}

	get module(): string {
		return this.fg.get('module').value;
	}
	set module(val) {
		this.fg.get('module').setValue(val);
	}

	get entityId(): number {
		return this.fg.get('entityId').value;
	}
	set entityId(val) {
		this.fg.get('entityId').setValue(val);
	}

	get recordAffected(): string {
		return this.fg.get('recordAffected').value;
	}
	set recordAffected(val) {
		this.fg.get('recordAffected').setValue(val);
	}

	get secureArea(): string {
		return this.fg.get('secureArea').value;
	}
	set secureArea(val) {
		this.fg.get('secureArea').setValue(val);
	}

	get field(): string {
		return this.fg.get('field').value;
	}
	set field(val) {
		this.fg.get('field').setValue(val);
	}

	get changedFrom(): string {
		return this.fg.get('changedFrom').value;
	}
	set changedFrom(val) {
		this.fg.get('changedFrom').setValue(val);
	}

	get changedTo(): string {
		return this.fg.get('changedTo').value;
	}
	set changedTo(val) {
		this.fg.get('changedTo').setValue(val);
	}

	get changedBy(): string {
		return this.fg.get('changedBy').value;
	}
	set changedBy(val) {
		this.fg.get('changedBy').setValue(val);
	}

	get pfsLink(): string {
		return this.fg.get('pfsLink').value;
	}
	set pfsLink(val) {
		this.fg.get('pfsLink').setValue(val);
	}
}
